import { render, staticRenderFns } from "./bankruptcy-file.vue?vue&type=template&id=7bc3c662&"
import script from "./bankruptcy-file.vue?vue&type=script&lang=js&"
export * from "./bankruptcy-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports